<template>
    <div v-if="loggedIn">
        <BaseButton @click="toggleFollow" :class="{ 'button-add-interest': true, active: !!userInterestIdInternal }">
            <div>
                <i class="icon round-small icon-rate-star" :class="{ active: !!userInterestIdInternal }"></i>
                <div>
                    {{ !!userInterestIdInternal ? t.buttons.you_follow : t.buttons.follow }}
                </div>
            </div>
        </BaseButton>
        <BasePopup v-if="isLoginPopupOpen" @close="isLoginPopupOpen = false" class="tutkitpopup612">
            <div>
                <h3>{{ t.popup.fav_content_title }}</h3>
                <h4>
                    <b>{{ t.popup.fav_content_subtitle }}</b>
                </h4>
                <p>{{ t.popup.fav_content_text }}.</p>
                <div class="button-bar">
                    <BaseButton type="high" color="alternate" target="_direct" @click.prevent="routeRegister">
                        {{ t.buttons.register }}
                    </BaseButton>
                    <BaseButton type="high" @click.prevent="routeLogin">{{ t.buttons.login }}</BaseButton>
                </div>
            </div>
        </BasePopup>
    </div>
</template>

<script>
import BaseButton from "@/components/Buttons/BaseButton.vue"
import BasePopup from "@/components/Frontend/BasePopup.vue"
import DownloadInfo from "@/components/Frontend/DownloadInfo.vue"
import axios from "@/app/axios.ts"
import { openLoginRegistrationPopup } from "@/libs/helpers.ts"
const translationsData = window.translationsData

export default {
    name: "AddInterest",
    props: ["routeInterests", "userInterestId", "interestId", "loggedIn"],
    components: { BaseButton, BasePopup, DownloadInfo },
    data() {
        return {
            userInterestIdInternal: false,
            isLoginPopupOpen: false,
            t: translationsData.translations,
        }
    },
    created() {
        this.userInterestIdInternal = this.userInterestId
    },
    methods: {
        async toggleFollow() {
            if (this.userInterestIdInternal) {
                await axios.delete(`${this.routeInterests}/${this.interestId}`)
                this.userInterestIdInternal = false
            } else {
                if (!this.loggedIn) {
                    this.isLoginPopupOpen = true
                    return
                }
                const result = await axios.post(`${this.routeInterests}/${this.interestId}`)
                this.userInterestIdInternal = result.data.id
            }
        },
        routeLogin() {
            this.isLoginPopupOpen = false
            openLoginRegistrationPopup()
        },
        routeRegister() {
            this.isLoginPopupOpen = false
            openLoginRegistrationPopup("registration")
        },
    },
}
</script>
